import { toggleSwitchDriverFactory } from './ToggleSwitchCore/ToggleSwitchCore.driver';

export interface ToggleSwitchDriver
  extends ReturnType<typeof toggleSwitchDriverFactory> {
  getSize: () => string;
  getSkin: () => string;
}
